import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { Button } from '@leafwell/components';
import { useDraggableScroll } from 'hooks/useDraggableScroll';

const AlphabetList: React.FC<{
  initialLetter?: string;
  loading?: boolean;
}> = ({ initialLetter, loading }) => {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');
  const dragEl = useRef(null);
  const currentLetterRef = useRef(null);
  const activeLetter = initialLetter?.toLowerCase();
  const { onMouseDown, updateScroll } = useDraggableScroll({
    ref: dragEl,
    direction: 'horizontal',
  });
  const { asPath, locale, query } = useRouter();
  const path = asPath.replace(query?.slug as string, '').split('?')[0];
  const pathname = locale === 'en' ? path : `/${locale}${path}`;

  useEffect(() => {
    if (currentLetterRef?.current) {
      updateScroll(
        currentLetterRef.current.offsetLeft -
          window.innerWidth / 2 +
          currentLetterRef.current.offsetWidth / 2,
      );
    }
  }, [currentLetterRef]);

  return (
    <ul
      ref={dragEl}
      className="grid grid-flow-col gap-x-2 lg:gap-x-1 overflow-x-auto hide-scrollbar"
      onMouseDown={onMouseDown}
    >
      {alphabet.map(letter => {
        const isActive = activeLetter === letter;

        return (
          <li key={letter} {...(isActive ? { ref: currentLetterRef } : {})}>
            <Button
              label={letter}
              loading={loading && isActive}
              size="small"
              variant={isActive ? 'primary' : 'secondary'}
              filled={false}
              className={[
                'p-reset inline-grid items-center w-8 h-8 uppercase text-sm font-sans font-medium rounded-full',
                isActive
                  ? 'bg-green-100 pointer-events-none'
                  : '!border-indigo-200',
              ].join(' ')}
              href={`${pathname}?letter=${letter}`}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default AlphabetList;
